import React from 'react';
import { Text, Button } from '@fragments';
import { IconExternalLink, IconCircleCheck, IconCircleX, IconArrowsHorizontal, IconX } from '@tabler/icons-react';
import { getChargebackReason } from '../../../enums/chargebackReasons';
import './styles.scss';

const RESOLVED_STATUSES = ['won', 'lost', 'closed', 'reversed'];

const RESOLVED_MESSAGES = {
    won: {
        title: 'Contestação resolvida a seu favor',
        description: 'Esta contestação foi analisada e resolvida a seu favor. O valor permanece em sua conta.',
    },
    lost: {
        title: 'Contestação resolvida a favor do comprador',
        description: 'Esta contestação foi analisada e o valor foi devolvido ao titular do cartão.',
    },
    reversed: {
        title: 'Contestação revertida',
        description: 'A decisão desta contestação foi revertida.',
    },
    closed: {
        title: 'Contestação encerrada',
        description: 'Esta contestação foi encerrada.',
    },
};

const UNDER_REVIEW_MESSAGE = {
    title: 'Sua evidência de disputa foi enviada',
    description: 'Nós enviamos a documentação de disputa para a emissora do cartão. Eles farão a decisão final, e você será notificado assim que eles responderem. Geralmente a análise acontece dentro de 3 meses',
};

export default function ContestationAlert({ reason, status, onAccept, onDispute }) {
    const isResolved = RESOLVED_STATUSES.includes(status);
    const isUnderReview = status === 'under_review';
    const resolvedMessage = RESOLVED_MESSAGES[status];
    const reasonData = getChargebackReason(reason);

    const activeMessage = isUnderReview
        ? UNDER_REVIEW_MESSAGE
        : { title: 'Este pagamento foi contestado', description: reasonData.description };

    const title = isResolved && resolvedMessage ? resolvedMessage.title : activeMessage.title;
    const bodyText = isResolved && resolvedMessage ? resolvedMessage.description : activeMessage.description;

    // Instructions only apply while a dispute can still be filed — not once the
    // evidence is under review, nor after the case is resolved.
    const instructionsText = !isResolved && !isUnderReview ? reasonData.instructions : null;

    const titleIcon = {
        won: <IconCircleCheck />,
        lost: <IconCircleX />,
        reversed: <IconArrowsHorizontal />,
        closed: <IconX />,
        under_review: <IconCircleCheck />,
    }[isUnderReview ? 'under_review' : 'lost'];

    return (
        <div className={`contestation-alert contestation-alert--${isResolved ? status : 'active'}`}>
            <div className="contestation-alert__body">
                <Text.h4 weight={400} left={titleIcon}>{title}</Text.h4>
                <div style={{ paddingLeft: '26px', paddingTop: '6px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <Text.span contrast={5} >
                        {bodyText}
                    </Text.span>
                    {instructionsText && (
                        <Text.span contrast={5}>
                            {instructionsText}
                        </Text.span>
                    )}
                </div>
            </div>

            <div className="contestation-alert__divider" />

            <div className="contestation-alert__footer">
                <a
                    href="https://help.ginastee.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contestation-alert__help-link"
                >
                    <Text.span>Saiba como responder a contestações</Text.span>
                    <IconExternalLink size={13} />
                </a>

                {['requested', 'waiting_documents'].includes(status) && (
                    <div className="contestation-alert__actions">
                        <Button
                            text="Refutar contestação"
                            color="primary"
                            size="small"
                            onClick={onDispute}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
